function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".bespoken_logoweb_svg__cls-2{fill:#00c8cb}.bespoken_logoweb_svg__cls-3{fill:#00a5b5}.bespoken_logoweb_svg__cls-4{fill:#7fd536}.bespoken_logoweb_svg__cls-5{fill:#43bd36}.bespoken_logoweb_svg__cls-6{fill:#ff9629}.bespoken_logoweb_svg__cls-7{fill:#e5312c}.bespoken_logoweb_svg__cls-8{fill:#f8e000}.bespoken_logoweb_svg__cls-9{fill:#f96528}.bespoken_logoweb_svg__cls-10{fill:#3a383b}"));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "bespoken_logoweb_svg__Capa_2",
  "data-name": "Capa 2"
}, React.createElement("g", {
  id: "bespoken_logoweb_svg__Capa_1-2",
  "data-name": "Capa 1"
}, React.createElement("path", {
  fill: "#4b9fad",
  d: "M31.72 3.96l-1.67 3.01-1.75.71L30.64.96l1.08 3z"
}), React.createElement("path", {
  className: "bespoken_logoweb_svg__cls-2",
  d: "M35.35 0l.54 4.01-2.91 2.74-1.98.66.31-.73L35.35 0z"
}), React.createElement("path", {
  className: "bespoken_logoweb_svg__cls-3",
  d: "M31.31 6.68l-4.01 9.35-1.88.06 2.88-8.41 1.75-.71 1.26-.29z"
}), React.createElement("path", {
  className: "bespoken_logoweb_svg__cls-2",
  d: "M31 7.41l2.49 7.28-6.19 1.34L31 7.41z"
}), React.createElement("path", {
  className: "bespoken_logoweb_svg__cls-3",
  d: "M36.17 7.25l-2.68 7.44L31 7.41l1.98-.66 3.19.5z"
}), React.createElement("path", {
  className: "bespoken_logoweb_svg__cls-3",
  d: "M41.07 10.19l-7.58 4.5 6.84-1.33.74-3.17z"
}), React.createElement("path", {
  className: "bespoken_logoweb_svg__cls-2",
  d: "M41.07 10.19l-4.9-2.94-2.68 7.44 7.58-4.5z"
}), React.createElement("path", {
  className: "bespoken_logoweb_svg__cls-4",
  d: "M25.32 20.37h9.89l-7.91-4.34-1.98 4.34z"
}), React.createElement("path", {
  className: "bespoken_logoweb_svg__cls-3",
  d: "M35.21 20.37l-1.72-5.68-6.19 1.34 7.91 4.34z"
}), React.createElement("path", {
  className: "bespoken_logoweb_svg__cls-4",
  d: "M24.71 25.04h11.92l-9.72-4.67-2.2 4.67z"
}), React.createElement("path", {
  className: "bespoken_logoweb_svg__cls-5",
  d: "M35.21 20.37l1.42 4.67-9.72-4.67h8.3zM26.3 25.04h10.33l-11.46 6.44 1.13-6.44z"
}), React.createElement("path", {
  className: "bespoken_logoweb_svg__cls-6",
  d: "M7.94 52.04l-4.5-7.3L4.6 40.4l9.35 11.98-3.62 14.73-2.39-15.07z"
}), React.createElement("path", {
  className: "bespoken_logoweb_svg__cls-7",
  d: "M7.94 52.04l-4.5 11.44V44.74l4.5 7.3z"
}), React.createElement("path", {
  className: "bespoken_logoweb_svg__cls-8",
  d: "M13.95 52.38l11.22-20.9L4.6 40.4l9.35 11.98z"
}), React.createElement("path", {
  className: "bespoken_logoweb_svg__cls-7",
  d: "M29.28 53.05l-5.6-.25 2.8 10.68 2.8-10.43z"
}), React.createElement("path", {
  className: "bespoken_logoweb_svg__cls-8",
  d: "M39.66 35.02l-14.49-3.54 11.46-6.44 3.03 9.98z"
}), React.createElement("path", {
  className: "bespoken_logoweb_svg__cls-9",
  d: "M29.28 53.05l-4.11-21.57-11.22 20.9 15.33.67z"
}), React.createElement("path", {
  className: "bespoken_logoweb_svg__cls-6",
  d: "M39.66 35.02L29.28 53.05l-4.11-21.57 14.49 3.54z"
}), React.createElement("path", {
  className: "bespoken_logoweb_svg__cls-9",
  d: "M32 67.11l-2.72-14.06 10.38-18.03L32 67.11z"
}), React.createElement("path", {
  className: "bespoken_logoweb_svg__cls-7",
  d: "M2.34 41.4l1.69 1.13-2.03.54-2-1.33 2.34-.34z"
}), React.createElement("path", {
  className: "bespoken_logoweb_svg__cls-8",
  d: "M4.6 40.4l-.57 2.13-1.69-1.13-.67-2 2.93 1z"
}), React.createElement("path", {
  className: "bespoken_logoweb_svg__cls-6",
  d: "M0 44.74l2-1.67 2.03-.54-.59 2.21H0z"
}), React.createElement("path", {
  className: "bespoken_logoweb_svg__cls-10",
  d: "M61.09 55.49V53q0-3-3.15-3H54.4v8.39h3.54c2.1 0 3.15-1 3.15-3M57.7 38.6h-3.3v8.23h3.3q3.16 0 3.16-3v-2.27c0-2-1-3-3.16-3m6.74 2.81v2.27c0 2.43-.92 4-2.77 4.69 2 .67 3 2.28 3 4.85v2.42a5.77 5.77 0 01-1.6 4.41 6.59 6.59 0 01-4.71 1.52h-7.58V35.48h7.35A6.59 6.59 0 0162.84 37a5.77 5.77 0 011.6 4.41M72.21 49.22h6v-4.08c0-2-1-3-3-3s-3 1-3 3zm-3.54 6.5V45.1a6 6 0 011.62-4.41 6.65 6.65 0 014.92-1.63q3.32 0 4.89 1.63a6.09 6.09 0 011.58 4.41v7h-9.47v3.39a2.69 2.69 0 001 2.27 5.52 5.52 0 003.3.73 15.44 15.44 0 004.6-.69v3.31a19.06 19.06 0 01-4.92.61q-7.47 0-7.47-6M84.41 44.83a5.18 5.18 0 011.64-4.19c1.09-.93 2.86-1.39 5.33-1.39a14.34 14.34 0 014.38.62v3.31a11.35 11.35 0 00-4.08-.7 5 5 0 00-3 .6A2.37 2.37 0 0088 45v.77a2.52 2.52 0 00.42 1.58A5.07 5.07 0 0090 48.53l3.3 1.77q3.32 1.77 3.31 4.77v1q0 5.7-7.39 5.69a19 19 0 01-4.73-.57v-3.35a13.8 13.8 0 004.33.65 6.22 6.22 0 003.27-.61A2.13 2.13 0 0093 56v-.65a2.18 2.18 0 00-.48-1.48 6.31 6.31 0 00-1.9-1.29L87.49 51a5.17 5.17 0 01-3.08-4.89zM109.35 45a2 2 0 00-2.35-2.29 7.59 7.59 0 00-3.39.85v14.7h2.77c2 0 3-.93 3-2.81zm-5.89-4.51a10 10 0 014.54-1.12 5.14 5.14 0 013.66 1.27 4.84 4.84 0 011.34 3.73v11.47a5.59 5.59 0 01-1.56 4.25 5.78 5.78 0 01-4.17 1.48h-3.66v5.73H100V39.44h3.46zM126.51 45.18a3 3 0 10-5.93 0v10.66a3 3 0 005.93 0zM117 45.1a6 6 0 011.61-4.41 8.29 8.29 0 019.87 0 6 6 0 011.64 4.41v10.81a6 6 0 01-1.64 4.41 8.25 8.25 0 01-9.87 0 6 6 0 01-1.61-4.41zM143.25 39.44H147L142.63 50l4.78 11.54h-3.89L138.9 50zm-8.77-5.88H138v28h-3.54zM153.49 49.22h6v-4.08q0-3-3-3c-2 0-3 1-3 3zm-3.49 6.5V45.1a6 6 0 011.61-4.41 6.66 6.66 0 014.93-1.63 6.5 6.5 0 014.88 1.63A6 6 0 01163 45.1v7h-9.46v3.39a2.69 2.69 0 00.94 2.27 5.56 5.56 0 003.31.73 15.49 15.49 0 004.6-.69v3.31a19.08 19.08 0 01-4.93.61q-7.47 0-7.46-6M170.53 40.44a11.67 11.67 0 014.6-1.07 4.59 4.59 0 014.87 5v17.2h-3.69V45a2 2 0 00-2.31-2.29 7.49 7.49 0 00-3.35.85v18h-3.62V39.44h3.46z"
})));

var SvgBespokenLogoweb = function SvgBespokenLogoweb(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 180 67.3"
  }, props), _ref, _ref2);
};

export default SvgBespokenLogoweb;